import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidCategorise } from '../../../../../mechanics/rid-categorise/rid-categorise';

@Component({
  selector: 'app-categorise-audio-to-word-page',
  imports: [RidCategorise],
  templateUrl: './categorise-audio-to-word-page.html',
})
export class CategoriseAudioToWordPage {
  protected readonly $router = inject(Router);
}
